import { styled } from '@mui/material';
import PhoneInput from 'react-phone-number-input';

export const StyledPhoneInput = styled(PhoneInput)`
  /* Override the input field's background color and border */
  .PhoneInputInput {
    background-color: #f7edf4;
    border: 1px solid #f7edf4;
    padding: 8px;
    border-radius: 4px;
    height: 40px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  .PhoneInputInput:focus {
    outline-color: #f7edf4;
  }

  /* Style the placeholder text */
  .PhoneInputInput::placeholder {
    color: #999;
  }

  /* Style the country select dropdown */

  /* Change the hover background color for dropdown options */
  .PhoneInputCountrySelectDropdownOption:hover {
    width: 66px;
    height: 40px;
  }
  .PhoneInputCountryIcon {
    font-size: 24px;
    border-radius: 4px;
    padding: 4px;
    width: 66px;
    height: 40px;
  }
`;
